import { StoryblokHeroSection } from './StoryblokHeroSection'

import { createHeroSection } from './__mocks__/heroSection'

export { createHeroSection }

// Re-export for backward compatibility
export const dummyBlokHeroSectionStoryblok = createHeroSection()

export default StoryblokHeroSection
